import Categories from "../features/inventory/Categories"

const InventoryCategoriesPage = () => {
    return (
        <>
        <Categories />
        </>
    )
}
export default InventoryCategoriesPage